module.exports = __webpack_public_path__ + "assets/retina_ShiftSegmentDetailed.29f9b029ffa11b5dc05e192cae61a727.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_ShiftSegmentDetailed.png
// module id = 714
// module chunks = 0